/* Static diagnostic labels only. No tracker loading, identity or consent writes. */
(function () {
  'use strict';
  if (window.__dublPdpDiagnostics) return;
  window.__dublPdpDiagnostics = true;
  var script = document.currentScript;
  if (!script) return;
  var model = script.dataset.model;
  var qa = script.dataset.editor === 'true';
  var key = 'dubl_pdp_qa';
  try {
    var params = new URLSearchParams(window.location.search);
    qa = qa || params.has('preview_theme_id') || params.get('dubl_qa') === '1';
  } catch (_) { return; }
  try {
    qa = qa || window.sessionStorage.getItem(key) === '1';
    if (qa) window.sessionStorage.setItem(key, '1');
  } catch (_) { /* Current-page exclusion still holds when storage is unavailable. */ }
  if (model !== 'Hyperion' && model !== 'Helios') return;
  var sent = false, timer = null, attempts = 0;
  function attempt() {
    timer = null;
    if (sent) return;
    attempts += 1;
    var allowed = false;
    try {
      allowed = window.Shopify.customerPrivacy.analyticsProcessingAllowed() === true;
    } catch (_) { /* Unknown means no tags. */ }
    if (allowed && typeof window.clarity === 'function') {
      var challenger = document.querySelector('[data-dubl-test-pdp][data-dubl-design="challenger"]');
      var original = document.querySelector('[id^="MainProduct-"].main-product');
      if (qa || (!!challenger !== !!original)) {
        try {
          if (qa) window.clarity('set', 'pdp_traffic', 'qa');
          else {
            window.clarity('set', 'pdp_design', challenger ? 'new' : 'original');
            window.clarity('set', 'pdp_model', model);
          }
          sent = true;
        } catch (_) { return; }
      }
    }
    if (!sent && attempts < 12) timer = window.setTimeout(attempt, 500);
  }
  function start() {
    if (sent) return;
    if (timer !== null) window.clearTimeout(timer);
    attempts = 0;
    attempt();
  }
  document.addEventListener('visitorConsentCollected', start);
  window.addEventListener('load', start, { once: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
